export default {
	methods: {
		isVoucher(discount) {
			return discount && Array.isArray(discount.voucherPattern) && discount.voucherPattern.length > 0;
		},
		discountPrice(item) {
			if(typeof item.productPrice === "object") {
				const productData = item.product ? item.product : item;
				const {discount, options} = productData;
				if(this.isVoucher(discount) || (options.isPrize && options.isPrize.fromGame)) {
					return item.productPrice.basePrice;
				} else {
					return item.productPrice.discountPrice;
				}
			}
			return item.productPrice;
		}
	}
};
